import { render, staticRenderFns } from "./SortingModalWrapper.vue?vue&type=template&id=1a9157c8&scoped=true"
import script from "./SortingModalWrapper.vue?vue&type=script&lang=js"
export * from "./SortingModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9157c8",
  null
  
)

export default component.exports